import { render, staticRenderFns } from "./StatItem.vue?vue&type=template&id=644b03db"
import script from "./StatItem.vue?vue&type=script&lang=js"
export * from "./StatItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports